import { ISnotrRoute } from '..';

export default [
  {
    path: '/recurring-orders',
    name: 'RecurringOrders',
    meta: {
      title: 'TabTitle.recurringOrders',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/recurring-orders.vue'),
  },
  {
    path: '/recurring-orders/new',
    name: 'RecurringOrdersNew',
    meta: {
      title: 'TabTitle.recurringOrdersNew',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/recurring-orders-new.vue'),
  },
  {
    path: '/recurring-orders/:id',
    name: 'RecurringOrdersEdit',
    meta: {
      title: 'TabTitle.recurringOrdersEdit',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/recurring-orders-edit.vue'),
  },
] as ISnotrRoute[];
